export const BASE_IMAGE_PATH = 'https://storage.googleapis.com/hutw/images'

export const APPLY_17_LIVE_FORM_PATH = 'https://forms.gle/zrirhUwqNtCjHBZo7'
